import {
  SAVECALCULATION,
  GETUSERCALCULATIONS,
  DELETEUSERCALCULATION
} from './urls';

import { conn } from './conn';

import calcModel from '../models/calculation';

const saveCalculation = async (calc)=>{
  calc=calcModel(calc).final();

  console.log('SAVING CALC - FINAL STEP',calc);

  const { data } = await conn().post(SAVECALCULATION,calc);
  console.log('CALCULATION saved return',data);
  return data;

}


const loadCalculations = async ()=>{
  const { data } = await conn().get(GETUSERCALCULATIONS);
  return data;
}

const deleteCalculation = async (id)=>{
  const { data } = await conn().delete(DELETEUSERCALCULATION+'/'+id);
  // {"n":1,"ok":1,"deletedCount":1}
  if(data.deletedCount) {
    return true;
  }
  throw new Error('Error deleting calculation: '+id);
}




export {
  saveCalculation,
  loadCalculations,
  deleteCalculation
}